import { render, staticRenderFns } from "./SunburstChart.vue?vue&type=template&id=653a8123"
import script from "./SunburstChart.vue?vue&type=script&lang=js"
export * from "./SunburstChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports